import apiClient from "config/apiClient";
import Healthplanpolicies from "./healthplanpolicies";
import PolicyAdoption from "./policyAdoption";
import HealthPlanList from "./HealthPlanList";
import HealthPlanConfig from "./HealthPlanConfig";
import PolicyEnforcementGrid from "./PolicyEnforcementGrid";
import Healthcheck from "./healthcheck";
import DiagnosisCode from "./diagnosisCode";
import ProcedureCode from "./procedureCode";
import FeatureFlag from "./featureFlag";
import PolicyData from "./policyData";
import Workspace from "./workspace";
import RuleConfigProcess from "./ruleConfigProcess";
import RulesEditor from "./rulesEditor";
import PolicyRules from "./policyRules";
import ReleaseSchedule from "./releaseSchedule";
import ReleaseApproval from "./releaseApproval";
import PolicyConfiguration from "./policyConfiguration";
import PolicyCodingApi from "./policyCoding";
import UserActivity from "./userActivity";
import CodeGroup from "./codegroup";
import Lob from "./lob";

const Api = {
  healthplanpolicies: new Healthplanpolicies(apiClient),
  policyAdoption: new PolicyAdoption(apiClient),
  healthPlanList: new HealthPlanList(apiClient),
  healthPlanConfig: new HealthPlanConfig(apiClient),
  policyEnforcementGrid: new PolicyEnforcementGrid(apiClient),
  healthcheck: new Healthcheck(apiClient),
  diagnosisCode: new DiagnosisCode(apiClient),
  procedureCode: new ProcedureCode(apiClient),
  featureFlag: new FeatureFlag(apiClient),
  policyData: new PolicyData(apiClient),
  workspace: new Workspace(apiClient),
  ruleConfigProcess: new RuleConfigProcess(apiClient),
  rulesEditor: new RulesEditor(apiClient),
  PolicyRules: new PolicyRules(apiClient),
  ReleaseSchedule: new ReleaseSchedule(apiClient),
  ReleaseApproval: new ReleaseApproval(apiClient),
  PolicyConfiguration: new PolicyConfiguration(apiClient),
  policyCoding: new PolicyCodingApi(apiClient),
  UserActivity: new UserActivity(apiClient),
  CodeGroup: new CodeGroup(apiClient),
  Lob: new Lob(apiClient),
};

export default Api;
